import { z } from 'zod';
export const getQSTActionDetailSchema = z.array(
  z.object({
    id: z.string(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
    sequence: z.number(),
    qstActionID: z.string(),
    description: z.string(),
    isSettled: z.boolean(),
    updateUserID: z.string().optional(),
  })
);
export type GetDeliveryTypesResponse = z.infer<typeof getQSTActionDetailSchema>;
